import { queryOptions } from '@tanstack/react-query';
import type { ExtractorConfigDto } from '@upme/contracts';
import { api } from '../../app/api-client';

export const extractorConfigKey = ['admin', 'extractor-config'] as const;

export const extractorConfigOptions = () =>
  queryOptions({
    queryKey: [...extractorConfigKey],
    queryFn: () => api.get('admin/extractor-config').json<ExtractorConfigDto>(),
    staleTime: 30_000,
  });
